<template>
    <div class="dgov2-slickslideshow" :unique-id="uniqueId" v-bind:style="{visibility:visibility}">
        <slot />
    </div>
</template>

<script>
    const DEBUG=false;
    export default {
        name: 'slickSlideShow',
        props: {
            mediaHeight: {
                type: Number,
                default: "100%",
            },
            onSlideChange: {
                type: Function,
            },
            initialSlide: {
                type: Number,
                default: 0
            },
            uniqueId: {
                type: String,
                default: "-not-unique"
            }
        },
        data: function() {
            return {
                slickInstance: null,
                mediaHeight: null,
                visibility: "hidden",
            };
        },
        computed: {
        },
        methods: {
            destroySlick() {
                if(DEBUG) console.log("destroySlick",this.slickInstance)
                this.slickInstance.unslick();
                this.slickInstance=null;
            },
            initSlick() {
                if(DEBUG) console.log("init");
                const el=document.querySelector(`.dgov2-slickslideshow[unique-id='${this.$props.uniqueId}']`);
                if(DEBUG) console.log("slideshow target",el);
                const jel=$(el);
                // slick needs init handler attached before calling .slick(initopts)
                jel.on('init',(slick) => {
                    setTimeout(() => {
                        this.visibility="visible";
                    },10);
                });
                const ss=jel
                    .slick({
                        arrows: true,
                        infinite: true,
                        dots: false,
                        adaptiveHeight: false,
                        respondTo: "window",
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        initialSlide: this.$props.initialSlide,
                    });
                ss.on('beforeChange',(event,slick,currentSlide,nextSlide) => {
                    if(DEBUG) console.log("ss44: slide",
                        { currentSlide,nextSlide });

                    // pause all videos here
                    $("iframe.YouTubeVideo").each(function() {
                        const player=new YT.get(this.id);
                        if(typeof player.pauseVideo==='function')
                            player.pauseVideo();
                    })

                    // Pause all dvids videos
                    $("video.dvidsPlayer").each(function() {
                        if(typeof this.pause==='function')
                            this.pause();
                    })

                    if(this.$props.onSlideChange) {
                        this.$props.onSlideChange(nextSlide);
                    }
                });

                ss.on('setPosition',() => {
                    // make sure clones have right height
                    $('.slick-slide .cropzoomimg-container').height(this.$props.mediaHeight);
                });
                this.slickInstance=ss.slick("getSlick");

                if(this.$props.onSlideChange) {
                    // tell our callback the slide we have atm
                    this.$props.onSlideChange(this.$props.initialSlide);
                }
                setTimeout(() => {
                    this.handleCurrentSize();
                },10);
            },
            handleCurrentSize: function() {
                const divWidth=this.$el.offsetWidth;
                const divHeight=this.$el.offsetHeight;
                if(this.$props.mediaHeight) {
                    this.mediaHeight=this.$props.mediaHeight;
                }
                if(DEBUG) console.log("slickSlideShow handleCurrentSize",
                    {
                        divWidth,divHeight,
                        mediaHeight: this.$props.mediaHeight,
                        ssObj: this.slickInstance,
                    });

                this.$nextTick(() => {
                    if(this.slickInstance) {
                        this.slickInstance.windowWidth++;
                        this.slickInstance.resize();
                        //this.slickInstance.refresh();
                    }
                });

            }
        },
        beforeDestroy: function() {
            if(DEBUG) console.log("sss66: beforeDestroy");
            this.destroySlick();
        },
        // Life Cycle
        created: function() {
            window.addEventListener('resize',() => this.handleCurrentSize());
        },

        mounted: function() {
            // save slides to be
            if(DEBUG) console.log("this slots",this.$slots)
            this.saveOrigSlides=this.$slots.default;
            this.visibility="hidden";
            setTimeout(() => {
                this.initSlick();
            },20);
        },
    };
</script>

<style lang="scss">
    .dgov2-slickslideshow {
        height: 100%;
        .slick-list, .slick-track

    {
        height: 100%;
    }

    .slick-slide > div {
        height: 100%
    }

    .slick-prev.slick-arrow {
        margin-left: 60px;
    }

    .slick-next.slick-arrow {
        margin-right: 50px;
    }

    .slick-prev.slick-arrow, .slick-next.slick-arrow {
        z-index: 1000;
        width: 50px;
        align-items: center;
        bottom: auto;
        color: #fff;
        display: flex;
        height: 50px!important;
        justify-content: center;
        position: absolute;
        top: 50%;
        text-align: center;
        font-size: 0 !important;
    }

    .slick-prev.slick-arrow:hover:before,
    .slick-next.slick-arrow:hover:before {
        opacity: 1;
    }

    .slick-prev.slick-arrow:before, .slick-next.slick-arrow:before {
        font-family: "Font Awesome 5 Free";
        font-style: normal;
        font-variant: normal;
        font-weight: 700;
        font-size: 2.4rem;
        text-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
        color: white;
        opacity: .7;
        vertical-align: top;
    }

    .slick-next:focus:before, .slick-next:hover:before,
    .slick-prev:focus:before, .slick-prev:hover:before {
        opacity: 1;
    }

    .slick-prev.slick-arrow:before {
        content: "\f053";
    }

    .slick-next.slick-arrow:before {
        content: "\f054";
    }
    }

    /* PW_KYMST-1129: Fix for IE 11 video flicker bug - https://github.com/kenwheeler/slick/issues/1911*/
    .slick-slide:not(.slick-current) .mejs__inner, .slick-slide:not(.slick-current) video {
        visibility: hidden !important;
    }
</style>
